
import SvgStarEmpty from '~/assets/svg/star-empty.svg?inline'
import SvgStarHalf from '~/assets/svg/star-half.svg?inline'
import SvgStarFilled from '~/assets/svg/star-filled.svg?inline'

export default {
  components: { SvgStarEmpty, SvgStarHalf, SvgStarFilled },
  inject: ['wordingPageProduct'],
  props: {
    productSelected: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      wordingPageProduct: this.wordingPageProduct,
      reviews: null,
    }
  },
  computed: {
    averageScoreFloat() {
      if (!this.reviews) return null
      return this.reviews.bottomline
        ? parseFloat(this.reviews.bottomline.average_score.toFixed(1))
        : null
    },
    averageScoreInt() {
      if (!this.reviews) return null
      return this.reviews.bottomline
        ? parseInt(this.reviews.bottomline.average_score)
        : null
    },
    customerReviews() {
      if (!this.reviews) return null
      return this.reviews.bottomline
        ? this.reviews.bottomline.total_review
        : null
    },
  },
}
